import { UserAssignment } from './user-assignment'

export class UserProfile {
    fullName: string;
    currentDesignation: string;
    isDelegatedUser: boolean;
    userTypeAssignments: UserAssignment[];
}